import { render, staticRenderFns } from "./Memo.vue?vue&type=template&id=ea4b2956&scoped=true&"
import script from "./Memo.vue?vue&type=script&lang=js&"
export * from "./Memo.vue?vue&type=script&lang=js&"
import style0 from "./Memo.vue?vue&type=style&index=0&id=ea4b2956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4b2956",
  null
  
)

export default component.exports